import axios from "axios";

axios.interceptors.response.use(
	function (response) {
		return response;
	},

	function (error) {
		const expectedError = error.response.status >= 400 && error.response.status < 501;

		if (expectedError) {


			// alert("Une erreur est survenue");
			return (
				{
					status: error.request.status,
					URL: error.request.responseURL
				},
				Promise.reject(error)
			);
		}

		return Promise.reject(error);
	}
);

export default {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete
};
